// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__eD5PH","col":"styles_col__3Ootl"};